export { default } from "./LineChartConfig";
